import { useId, useState, type ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';
import { Icon } from './Icon';

export interface DisclosureProps {
  label: string;
  /**
   * ОБЯЗАТЕЛЬНО. Свёрнутый блок называет свою величину: «39 категорий,
   * 46 738,78 га». Без числа перенос вглубь неотличим от удаления.
   */
  summary: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}

/** Жест «вглубь на месте»: раскрытие не уводит со страницы. */
export function Disclosure({ label, summary, defaultOpen = false, children }: DisclosureProps) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();

  return (
    <div className="disclosure">
      <button
        type="button"
        className="disclosure__trigger focus-ring"
        aria-expanded={open}
        aria-controls={`${id}-body`}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="disclosure__chev">
          <Icon icon={ChevronRight} size={16} />
        </span>
        <span className="disclosure__label">{label}</span>
        <span className="disclosure__summary">{summary}</span>
      </button>
      {open ? (
        <div className="disclosure__body" id={`${id}-body`}>
          {children}
        </div>
      ) : null}
    </div>
  );
}
